class ChooseSize extends HTMLElement {
  constructor() {
    super();

    this.openClass = "state--active";
  }

  connectedCallback() {
    this.button = this.querySelector(".choose-size__button");
    this.addButton = this.querySelector(".choose-size__add-button");
    this.addButtonPrice = this.addButton.querySelector(".choose-size__price");

    this.button.addEventListener("click", (event) => {
      this.onButtonClick(event);
    });

    this.addButton.addEventListener("click", (event) => {
      this.onAddButtonClick(event);
    });

    this.addEventListener("change", (event) => {
      this.onRadioChange(event);
    });

    document.addEventListener("click", (event) => {
      if (!event.target.closest("choose-size")) {
        this.hideList();
      }
    });
  }

  startLoading() {
    this.classList.add("loading");
  }

  finishLoading() {
    this.classList.remove("loading");
  }

  onRadioChange(event) {
    this.addButton.removeAttribute("disabled");

    const price = event.target.getAttribute("data-price");

    this.addButtonPrice.innerHTML = price;
  }

  showList() {
    this.classList.add(this.openClass);
  }

  hideList() {
    this.classList.remove(this.openClass);
  }

  hideAllLists() {
    document.querySelectorAll("choose-size").forEach((chooseSize) => {
      chooseSize.hideList();
    });
  }

  onAddButtonClick(event) {
    event.preventDefault();

    const checked = this.querySelector("[name=id]:checked");

    this.addButton.classList.add("loading");

    if (checked) {
      const id = checked.value;
      const quantity = 1;

      addToCart(id, quantity, {}, function () {
        document.dispatchEvent(new CustomEvent("addtocart"));
      });

      setTimeout(() => {
        this.addButton.classList.remove("loading");
      }, 2000);
    }
  }

  onButtonClick(event) {
    event.preventDefault();

    this.hideAllLists();
    this.showList();
  }
}

customElements.define("choose-size", ChooseSize);
